import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _WidgetAddLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("rect", { width: 7, height: 7, x: 3, y: 3, stroke: "currentColor", strokeLinecap: "round", rx: 1 }), _jsx("rect", { width: 7, height: 7, x: 3, y: 14, stroke: "currentColor", strokeLinecap: "round", rx: 1 }), _jsx("rect", { width: 7, height: 7, x: 14, y: 3, stroke: "currentColor", strokeLinecap: "round", rx: 1 }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M17.5 14v7M21 17.5h-7" })] }) });
}
const WidgetAddLight = forwardRef(_WidgetAddLight);
export { WidgetAddLight };
